import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ArrowUpIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ArrowUpIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19 10.9678C19 10.7743 18.9258 10.5808 18.7774 10.4331L12.5371 4.22154C12.2404 3.92615 11.7596 3.92615 11.4629 4.22154L5.22257 10.4331C4.92581 10.7285 4.92581 11.2071 5.22257 11.5025C5.51933 11.7979 6.00007 11.7979 6.29683 11.5025L12 5.82552L17.7032 11.5025C17.9999 11.7979 18.4807 11.7979 18.7774 11.5025C18.9258 11.3548 19 11.1613 19 10.9678Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.7592 19.2438L12.7592 4.7562C12.7592 4.33872 12.4189 4 11.9995 4C11.5801 4 11.2398 4.33872 11.2398 4.7562L11.2398 19.2438C11.2398 19.6613 11.5801 20 11.9995 20C12.4189 20 12.7592 19.6613 12.7592 19.2438Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ArrowUpIcon;
